export default __webpack_public_path__ + "static/media/doctor_button_active.bc25400a.svg";